import { createContext } from 'react';
// Lets a surface that reads the whole rendered subtree, such as find in page,
// mount every hidden child of `Virtualize` for as long as it needs them.
export const VirtualizeMountAllContext = createContext(false);
//# sourceMappingURL=VirtualizeMountAllContext.js.map